import pick from 'lodash/pick'
import FullTable from 'js/components/full-table/index.js'
import AnalyticsUtils from 'js/services/analytics-utils'

import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    leads: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dateConfig: {
        dateFormat: 'd/m/Y',
        allowInvalidPreload: true,
        enableTime: false
      },
      showFilters: true,
      filters: {phone: '', from: '', to: '', idLead: '', lastName: '', firstName: ''},
      initFilters: {phone: '', from: '', to: '', idLead: '', lastName: '', firstName: ''},
      lastQueryOptions: null // guarda los últimos filtros aplicados
    }
  },
  computed: {
    fromDateConfig() {
      return {
        maxDate: this.filters.to ? this.filters.to : null,
        ...this.dateConfig
      }
    },
    toDateConfig() {
      return {
        minDate: this.filters.from ? this.filters.from : null,
        ...this.dateConfig
      }
    },
    defaultOrder() {
      return {currentField: 'id', currentDir: 'asc'}
    },

    filterButtonParams() {
      if (this.showFilters) {
        return {class: 'active', icon: 'angle-up'}
      }

      return {class: '', icon: 'angle-down'}
    }
  },
  methods: {
    getFilters() {
      const filter = {
        ...this.filters,
        to: this.filters.to ? moment(this.filters.to).format('DD/MM/YYYY') : null,
        from: this.filters.from ? moment(this.filters.from).format('DD/MM/YYYY') : null
      }
      Object.entries(filter).forEach(([key, value]) => {
        if (!value) {
          delete filter[key]
        }
      })
      return filter
    },
    cleanFilters() {
      this.filters = JSON.parse(JSON.stringify(this.initFilters))
    },
    getData(queryOptions) {
      const filter = this.getFilters()
      // si borramos un elemento y recargamos, usamos los últimos filtros aplicados
      this.$emit('load-data', {filter, ...queryOptions || this.lastQueryOptions})

      if (queryOptions) this.lastQueryOptions = queryOptions
    },
    t(key, options = {}) {
      return this.$t(`logs.log-accepted-policy.${key}`, options)
    },
    exportLeads() {
      setTimeout(
        () => {
          this.loadLeadsCsv()
        },
        MOCKS ? 500 : 0
      )
    },
    downloadPdf(file) {
      AnalyticsUtils.downloadCsv({
        title: this.t('exportCsv.title'),
        url: file
      })
    },
    loadLeadsCsv() {
      const filter = this.getFilters()
      API.logs.exportAcceptedPolicyLogs(filter)
        .then(({data}) => {
          AnalyticsUtils.downloadCsv({
            title: this.t('exportCsv.title'),
            to: filter.to,
            from: filter.from,
            url: data.file
          })
        })
    }
  }
})
